import Component from '../../js/_Component';

export default class LayoutAtxUSidebar extends Component {
	constructor(element: HTMLElement) {
		super(element);

		// If we brought in the locate a dealer module on this page, remove it.
		if (document.querySelector('.c-layout-sidebar__body .module--locate')) {
			document.querySelector('.c-layout-sidebar__body .module--locate').remove();
		}

		if (document.querySelector('.c-layout-sidebar__body .c-schedule-demo-cta')) {
			document.querySelector('.c-layout-sidebar__body .c-schedule-demo-cta').remove();
		}

		// Removes the h1 class on the h2 within the cta component
		if (document.querySelector('.c-schedule-demo-cta .c-text h2')) {
			document.querySelector('.c-schedule-demo-cta .c-text h2').classList.remove('h1');
		}
	}
}

Component.register(LayoutAtxUSidebar, 'LayoutAtxUSidebar');
